import { render, staticRenderFns } from "./ZoomControls.vue?vue&type=template&id=58d8e187&scoped=true"
import script from "./ZoomControls.vue?vue&type=script&lang=js"
export * from "./ZoomControls.vue?vue&type=script&lang=js"
import style0 from "./ZoomControls.vue?vue&type=style&index=0&id=58d8e187&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d8e187",
  null
  
)

export default component.exports